import { render, staticRenderFns } from "./GroupClassList.vue?vue&type=template&id=452d876d"
import script from "./GroupClassList.vue?vue&type=script&lang=js"
export * from "./GroupClassList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports